// function cOptionsSocial() {
//     var self = this;
//     $(function () { self.onload(); });
// }

// cOptionsSocial.prototype.onload = function () {
//     var self = this;

//     var elBtnSaveSocialOptions = $("#save-social-options-btn");
//     this.elSocialOptionsEditFrom = $('#social-form');

//     $(elBtnSaveSocialOptions).click(function (e) { return self.onBtnSaveSocialOptionsClick(this, e) });
// }

// cOptionsSocial.prototype.onBtnSaveSocialOptionsClick = function (btn, e) {
//     $(btn).button('loading');

//     $(this.elSocialOptionsEditFrom).ajaxSubmit({
//         url: URL_ADMIN + '/options/main/updatesocial/',
//         type: 'post',
//         dataType: 'json',
//         success: function (response, statusText, xhr, el) {
//             if (response.success) {
//                 notify.success(response.message);
//             } else {
//                 notify.error(response.errors[0]);
//             }
//             $(btn).button('reset');
//         },
//         error: function (jqXHR) {
//             return ajaxErrorCallback(jqXHR, btn);
//         },
//     });
// }
